import type { CostIndexData, Product, RecordRow } from "./api";
import { RECORD_COLUMNS as ENGINE_RECORD_COLUMNS, toCsvRows } from "./records";

/** The engine's GET /records.csv column set, in its order (C2 main.py get_records_csv). */
export const RECORD_COLUMNS = ENGINE_RECORD_COLUMNS;

const cell = (value: unknown): string => {
  const text = value === null || value === undefined ? "" : String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, "\"\"")}"` : text;
};

export function recordsCsv(rows: RecordRow[], products?: Product[]): string {
  const lines = products === undefined
    ? [RECORD_COLUMNS.map(String), ...rows.map((row) => RECORD_COLUMNS.map((column) => column === "derived_from_sku" ? row.derived_from_sku.join(",") : (row as Record<string, unknown>)[column]))]
    : toCsvRows(rows, products);
  return `${lines.map((row) => row.map(cell).join(",")).join("\r\n")}\r\n`;
}

export function recordsFilename(entity: string, since: string, until: string): string {
  return `pcogs-records-${entity}-${since}-to-${until}.csv`;
}

export const COST_INDEX_SERIES_COLUMNS = ["month", "line_key", "label", "kind", "unit_cost", "index", "total_unit_cost", "total_index", "data_quality", "reference_inflation_pct"] as const;
export const COST_INDEX_CLIMBERS_COLUMNS = ["table", "key", "sku", "product", "variant", "region", "label", "kind", "base_unit_cost", "latest_unit_cost", "delta_abs", "delta_pct", "top_contributing_line", "units_sold_window", "impact_window"] as const;

export function costIndexSeriesCsv(data: CostIndexData): string {
  const rows = data.series.flatMap((point) => point.lines.map((line) => [
    point.month, line.key, line.label, line.kind, line.unit_cost, line.index,
    point.total_unit_cost, point.total_index, point.data_quality, data.reference_inflation?.cumulative_pct ?? "",
  ]));
  return `${[COST_INDEX_SERIES_COLUMNS, ...rows].map((row) => row.map(cell).join(",")).join("\r\n")}\r\n`;
}

export function costIndexClimbersCsv(data: CostIndexData): string {
  const lineRows = data.climbers.map((row) => [
    "cost_line", row.key, "", "", "", "", row.label, row.kind, row.base_unit_cost, row.latest_unit_cost,
    row.delta_abs, row.delta_pct, "", row.units_sold_window, row.impact_window,
  ]);
  const skuRows = data.sku_climbers.map((row) => [
    "sku", "", row.sku, row.tracking, row.variant, row.region, "", "", row.base_unit_cost, row.latest_unit_cost,
    row.delta_abs, row.delta_pct, row.top_contributing_line?.label ?? "", row.units_sold_window, row.impact_window,
  ]);
  return `${[COST_INDEX_CLIMBERS_COLUMNS, ...lineRows, ...skuRows].map((row) => row.map(cell).join(",")).join("\r\n")}\r\n`;
}
